import { render } from "./TemplateCreateView.vue?vue&type=template&id=382eab00&scoped=true"
import script from "./TemplateCreateView.vue?vue&type=script&lang=js"
export * from "./TemplateCreateView.vue?vue&type=script&lang=js"

import "./TemplateCreateView.vue?vue&type=style&index=0&id=382eab00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382eab00"]])

export default __exports__